import Cookies from "universal-cookie";
import { getCurrentTimestamp } from "../DatePicker/DateConverter";

function NameTheCSV(page,component) {
  
  const cookies = new Cookies();

  const userName = cookies.get("name").split(" ");

  const mynewTime = getCurrentTimestamp("DDMMMYY-HH:mm:ss")

  const name = component.split(" ");

  const name2 = name.join("_");

  return [mynewTime,userName[0],page,name2].join("_");
}

export default NameTheCSV;
